import { debounce } from '../../../scripts/utils/debounce.js';
import { tns } from '../../../node_modules/tiny-slider/src/tiny-slider.js';

export default class ProductImagesApp {
	constructor() {
		this.body = document.querySelector('body');
		this.product_zoom = document.querySelector('#product-zoom');
		this.btn_zoom_close = document.querySelector('.zoom-close');
		this.main_img = document.querySelector('#product-main-image');
		this.main_img_container = document.querySelector('.product-image');
		this.gallery = document.querySelector('.image-gallery-slider');
		this.imageGalleryMobile = document.querySelector('.image-gallery-mobile');
		this.videos = document.querySelector('#product-videos');
		this.slider = null;
		this.zoom = null;
		this.images = [];

		this.initGallery();
		this.bindEvents();
	}

	changeMainImg(el) {
		if (el.classList.contains('active')) {
			return false;
		}

		const imgs = this.gallery.querySelectorAll('.image');
		const img = el.querySelector('img');
		const src = img.getAttribute('src');
		let imgSrc = this.getImageSize( src, 'pimages' );

		if (img.dataset.furl) {
			imgSrc = img.dataset.furl;
		}

		if (this.videos) {
			this.videos.classList.add('d-none');
		}

		this.product_zoom.classList.remove('d-none');

		imgs.forEach(elem => elem.classList.remove('active'));

		el.classList.add('active');

		this.main_img.setAttribute('src', imgSrc);
		this.addMainImageProgress();
	}

	getImageNameByPath(path) {
		return path.replace( /(.*\/pmidimages\/)|(.*\/pthumbs\/)|(.*\/pimages\/)/ig, '' );
	}

	getImageSize( path, size ) {
		return path.replace( /(\/pmidimages\/)|(\/pthumbs\/)|(\/pimages\/)/ig, `/${size}/` );
	}

	updateGalleryImgs( gallery_imgs ) {
		gallery_imgs.forEach((el, i) => {
			const img = el.querySelector('img');
			const img_src = img.getAttribute('src');
			const img_name = this.getImageNameByPath( img_src ).toLowerCase();
			const main_img_name = this.getImageNameByPath( this.main_img.getAttribute('src') ).toLowerCase();

			el.setAttribute('data-name', img_name);

			if ( img.getAttribute('data-src') ) {
				img_name = this.getImageNameByPath( img.getAttribute('data-src') ).toLowerCase();
			}

			if ( main_img_name === img_name ) {
				el.classList.add('active');
			}

			el.setAttribute('data-img-number', i);
			el.addEventListener('click', () => this.changeMainImg(el));
		});
	}

	destroyDesktopGallery() {
		if (this.slider && this.slider.destroy) {
			this.slider.destroy();
		}
	}

	destroyMobileGallery() {
		if (this.mobileSlider && this.mobileSlider.destroy) {
			this.mobileSlider.destroy();
		}
	}

	showVideo( video_id ) {
		const video = this.videos.querySelector('.embed-video[data-video-id="' + video_id + '"]');
		const video_thumb = this.gallery.querySelector('.video-placeholder[data-video-id="' + video_id + '"]');

		if (video) {
			const load_preview_event = new CustomEvent('[product-video]:load-preview', { detail: video });
			const active_img = this.gallery.querySelector('.image.active');
			const active_video = this.videos.querySelector('.active');

			document.dispatchEvent(load_preview_event);

			if (active_img) {
				active_img.classList.remove('active');
			}

			if (active_video) {
				active_video.classList.remove('active');
				active_video.classList.add('d-none');
			}

			this.product_zoom.classList.add('d-none');
			this.videos.classList.remove('d-none');

			video.classList.add('active');
			video.classList.remove('d-none');

			video_thumb.classList.add('active');
			video_thumb.classList.remove('d-none');
		}
	}

	showMobileVideo( videoId ) {
		const videoHolderElement = this.imageGalleryMobile.querySelector(`.video[data-video-id="${videoId}"]`);

		if (videoHolderElement) {
			const loadVideoPreviewEvent = new CustomEvent('[product-video]:load-preview', { detail: videoHolderElement });

			document.dispatchEvent(loadVideoPreviewEvent);
		}
	}

	getNewElementsFromDOM() {
		const gallery_imgs = this.gallery.querySelectorAll('.image:not(.video-placeholder');
		this.updateGalleryImgs( gallery_imgs );
	}

	initGallery() {
		if (this.gallery) {
			this.destroyDesktopGallery();
			this.destroyMobileGallery();

			if( window.innerWidth < 768 ) {
				this.product_zoom.style.cssText = 'display: none;';
				this.gallery.style.cssText = 'display: none;';
				
				if(!!this.imageGalleryMobile) {
					this.imageGalleryMobile.style.cssText = '';
				}

				this.initGalleryMobile();
			} else {
				this.product_zoom.style.cssText = '';
				this.gallery.style.cssText = '';

				if(!!this.imageGalleryMobile) {
					this.imageGalleryMobile.style.cssText = 'display: none;';
				}

				this.initGalleryDesktop();
			}
		}
	}

	initGalleryDesktop() {
		if( this.gallery && this.gallery.querySelectorAll('.image').length > 1 ) {

			var slider_opts = {
				container: '.image-gallery-container',
				axis: window.innerWidth < 768 ? 'horizontal' : 'vertical',
				items: 3,
				gutter: 3,
				nav: false,
				loop: false,
				responsive: {
					768: {
						items: 6,
						gutter: 0
					},
					1400: {
						items: 7
					}
				}
			};

			this.slider = tns(slider_opts);

			setTimeout(this.getNewElementsFromDOM.bind(this), 400);

			// Videos

			const gallery_videos = this.gallery.querySelectorAll('.video-placeholder');

			gallery_videos.forEach(el => el.addEventListener('click', () => {
				this.showVideo( el.getAttribute('data-video-id') );
			}));

		} else if ( this.gallery ){
			this.gallery.remove();
		}
	}

	initGalleryMobile() {
		if(!this.imageGalleryMobile) {
			return;
		}

		var container = this.imageGalleryMobile.querySelector('ul');

		this.mobileSlider = tns({
			container,
			items: 1,
			gutter: 0,
			nav: true,
			loop: false
		});

		setTimeout(() => container.querySelectorAll('.video').forEach(element => this.showMobileVideo( element.dataset.videoId )), 1000);
	}

	removeMainImageProgress() {
		this.main_img_container.classList.remove('progress');
	}

	addMainImageProgress() {
		this.main_img_container.classList.add('progress');
	}

	mainImageLoad() {
		this.main_img_container.classList.remove('no-zoom');
		this.removeMainImageProgress();

		this.main_img.style.opacity = 1;

		this.main_img.src

		if( !this.images.includes(i => i.src === this.main_img.src) ) {
			this.images.push({
				src: this.main_img.src,
				width: this.main_img.naturalWidth,
				height: this.main_img.naturalHeight
			});
		}

		var img = this.images.find(i => i.src === this.main_img.src);

		if( this.body.classList.contains('zoom-mode') ) {
			this.initImageZoom(img);
		}
	}

	mainImageError() {
		this.removeMainImageProgress();
	}

	bindEvents() {
		this.main_img.addEventListener('load', () => this.mainImageLoad());
		this.main_img.addEventListener('error', () => this.mainImageError());

		this.main_img_container.addEventListener('click', () => this.toggleZoomMode());
		this.btn_zoom_close.addEventListener('click', () => this.closeZoomMode());

		//window.addEventListener('resize', debounce(() => this.initGallery(), 250));
	}

	toggleZoomMode() {
		if (window.innerWidth > 768) {
			this.body.classList.toggle('zoom-mode');

			if( this.body.classList.contains('zoom-mode') ) {
				this.main_img.src = this.getImageSize( this.main_img.src, 'pimages' );
			} else {
				this.destroyImageZoom();
			}
		}
	}

	closeZoomMode() {
		this.destroyImageZoom();
		this.body.classList.remove('zoom-mode');
	}

	initImageZoom(zoomedImg) {
		this.destroyImageZoom();

		var {width, height} = zoomedImg;
		var {offsetWidth, offsetHeight} = this.product_zoom;

		if((offsetWidth < width) || (offsetHeight < height)) {
			this.zoom = new ImageZoom( this.main_img_container, {
				img: zoomedImg.src,
				offset: {
					vertical: 0,
					horizontal: 10
				},
				zoomPosition: 'original'
			} );
		}
	}

	checkImgSize(src, callback) {
		var img = new Image();

		img.addEventListener('load', () => callback(img));
		img.src = src;
	}

	destroyImageZoom() {
		if( this.zoom ){
			this.zoom.kill();
			this.zoom = null;
		}
	}
}